<template>
  <section id="socialMedia">
    <ul class="icons">
      <li v-for="media in socialMedia" :key="media.name">
        <a :class="iconName(media.fontIcon)" :href="media.link" target="_blank">
          <span class="label">{{ media.name }}</span>
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import SocialMedia from "../data/SocialMedia.json";
export default {
  computed: {
    socialMedia() {
      return SocialMedia.sort(function(a, b) {
        return a.position > b.position;
      });
    }
  },
  methods: {
    iconName(icon) {
      return "icon " + icon;
    }
  }
};
</script>
